import { render } from "./BurstsPage.vue?vue&type=template&id=6c72460e&scoped=true&ts=true"
import script from "./BurstsPage.vue?vue&type=script&lang=ts"
export * from "./BurstsPage.vue?vue&type=script&lang=ts"

import "./BurstsPage.vue?vue&type=style&index=0&id=6c72460e&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c72460e"]])

export default __exports__